module.exports = {
  id: 16,
  name: 'Mini Squats',
  categories: ['strength', 'legs', 'balance'],
  sports: [
    'baseball',
    'basketball',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'beginner',
  skill: 'Strength',
  points: 9,
  instructions:
    'Mini squats time! Stand with feet apart, bend knees like sitting in a chair, then stand back up! This makes your legs strong!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to get super strong? Stand with your feet apart!',
    },
    {
      time: 3,
      text: "Let's power up and get started!",
    },
    {
      time: 6,
      text: '3, 2, 1, START!',
    },
    // SET 1 - 10 reps
    {
      time: 9,
      text: 'Number 1! Bend your knees and squat down like sitting in a chair!',
    },
    {
      time: 11,
      text: 'Push through your feet and stand back up tall!',
    },
    {
      time: 13,
      text: 'Number 2! Bend your knees and squat down!',
    },
    {
      time: 15,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 17,
      text: 'Number 3! Squat down like sitting in a chair!',
    },
    {
      time: 19,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 21,
      text: 'Number 4! Bend your knees and squat down!',
    },
    {
      time: 23,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 25,
      text: 'Number 5! Squat down like sitting in a chair!',
    },
    {
      time: 27,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 29,
      text: 'Number 6! Bend your knees and squat down!',
    },
    {
      time: 31,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 33,
      text: 'Number 7! Squat down like sitting in a chair!',
    },
    {
      time: 35,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 37,
      text: 'Number 8! Bend your knees and squat down!',
    },
    {
      time: 39,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 41,
      text: 'Number 9! Squat down like sitting in a chair!',
    },
    {
      time: 43,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 45,
      text: 'Number 10! Last one of this set!',
    },
    {
      time: 47,
      text: 'Stand back up! Great job!',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 50,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 53,
      text: 'Shake out your legs and get ready!',
    },
    {
      time: 56,
      text: 'You are building strong legs!',
    },
    {
      time: 59,
      text: 'Ready for round two?',
    },
    {
      time: 62,
      text: '3, 2, 1, START!',
    },
    // SET 2 - 10 reps
    {
      time: 65,
      text: 'Number 1! Bend your knees and squat down like sitting in a chair!',
    },
    {
      time: 67,
      text: 'Push through your feet and stand back up tall!',
    },
    {
      time: 69,
      text: 'Number 2! Bend your knees and squat down!',
    },
    {
      time: 71,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 73,
      text: 'Number 3! Squat down like sitting in a chair!',
    },
    {
      time: 75,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 77,
      text: 'Number 4! Bend your knees and squat down!',
    },
    {
      time: 79,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 81,
      text: 'Number 5! Squat down like sitting in a chair!',
    },
    {
      time: 83,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 85,
      text: 'Number 6! Bend your knees and squat down!',
    },
    {
      time: 87,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 89,
      text: 'Number 7! Squat down like sitting in a chair!',
    },
    {
      time: 91,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 93,
      text: 'Number 8! Bend your knees and squat down!',
    },
    {
      time: 95,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 97,
      text: 'Number 9! Squat down like sitting in a chair!',
    },
    {
      time: 99,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 101,
      text: 'Number 10! Last one of this set!',
    },
    {
      time: 103,
      text: 'Stand back up! Great job!',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 106,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 109,
      text: 'Shake out your legs and get ready!',
    },
    {
      time: 112,
      text: 'You are building strong legs!',
    },
    {
      time: 115,
      text: 'Ready for round three?',
    },
    {
      time: 118,
      text: '3, 2, 1, START!',
    },
    // SET 3 - 10 reps
    {
      time: 121,
      text: 'Number 1! Bend your knees and squat down like sitting in a chair!',
    },
    {
      time: 123,
      text: 'Push through your feet and stand back up tall!',
    },
    {
      time: 125,
      text: 'Number 2! Bend your knees and squat down!',
    },
    {
      time: 127,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 129,
      text: 'Number 3! Squat down like sitting in a chair!',
    },
    {
      time: 131,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 133,
      text: 'Number 4! Bend your knees and squat down!',
    },
    {
      time: 135,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 137,
      text: 'Number 5! Squat down like sitting in a chair!',
    },
    {
      time: 139,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 141,
      text: 'Number 6! Bend your knees and squat down!',
    },
    {
      time: 143,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 145,
      text: 'Number 7! Squat down like sitting in a chair!',
    },
    {
      time: 147,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 149,
      text: 'Number 8! Bend your knees and squat down!',
    },
    {
      time: 151,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 153,
      text: 'Number 9! Squat down like sitting in a chair!',
    },
    {
      time: 155,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 157,
      text: 'Number 10! Last one of this set!',
    },
    {
      time: 159,
      text: 'Stand back up! Great job!',
    },
    // REST PERIOD 3 - 20 seconds
    {
      time: 162,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 165,
      text: 'Shake out your legs and get ready!',
    },
    {
      time: 168,
      text: 'You are building strong legs!',
    },
    {
      time: 171,
      text: 'Ready for the final round?',
    },
    {
      time: 174,
      text: '3, 2, 1, START!',
    },
    // SET 4 - 10 reps
    {
      time: 177,
      text: 'Number 1! Bend your knees and squat down like sitting in a chair!',
    },
    {
      time: 179,
      text: 'Push through your feet and stand back up tall!',
    },
    {
      time: 181,
      text: 'Number 2! Bend your knees and squat down!',
    },
    {
      time: 183,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 185,
      text: 'Number 3! Squat down like sitting in a chair!',
    },
    {
      time: 187,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 189,
      text: 'Number 4! Bend your knees and squat down!',
    },
    {
      time: 191,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 193,
      text: 'Number 5! Squat down like sitting in a chair!',
    },
    {
      time: 195,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 197,
      text: 'Number 6! Bend your knees and squat down!',
    },
    {
      time: 199,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 201,
      text: 'Number 7! Squat down like sitting in a chair!',
    },
    {
      time: 203,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 205,
      text: 'Number 8! Bend your knees and squat down!',
    },
    {
      time: 207,
      text: 'Push through your feet and stand back up!',
    },
    {
      time: 209,
      text: 'Number 9! Squat down like sitting in a chair!',
    },
    {
      time: 211,
      text: 'Stand back up tall and strong!',
    },
    {
      time: 213,
      text: 'Number 10! Last one ever!',
    },
    {
      time: 215,
      text: 'Stand back up! You are done!',
    },
    // COMPLETION
    {
      time: 218,
      text: 'Amazing work! You just did 40 mini squats!',
    },
    {
      time: 221,
      text: 'You are building incredible leg strength!',
    },
    {
      time: 224,
      text: 'Great job, strength champion!',
    },
  ],
};
